import React from 'react';
import classNames from 'classnames';
import bluePin from '../../../assets/blue.svg';
import checkedBluePin from '../../../assets/blueChecked.svg';
import greenPin from '../../../assets/green.svg';
import checkedGreenPin from '../../../assets/greenChecked.svg';
import { ensureListing } from '../../../util/data';
import { isPublicMoorageListing } from '../../../util/listingHelpers';
import { getActivePublicMoorageCheckIn } from '../../../util/publicMoorageCheckIn';

import css from './SearchMapIconPin.module.css';

const SearchMapIconPin = props => {
  const { rootClassName, className, listing, onListingClicked } = props;
  const isPublicMoorage = isPublicMoorageListing(listing?.attributes?.publicData);
  const activeCheckIn = getActivePublicMoorageCheckIn(listing);
  const pinImage = isPublicMoorage
    ? activeCheckIn
      ? checkedGreenPin
      : greenPin
    : activeCheckIn
    ? checkedBluePin
    : bluePin;
  const pinAlt = activeCheckIn
    ? isPublicMoorage
      ? 'Occupied public moorage map pin'
      : 'Occupied private moorage map pin'
    : isPublicMoorage
    ? 'Public moorage map pin'
    : 'Private moorage map pin';
  const classes = classNames(rootClassName || css.root, className, {
    [css.publicRoot]: isPublicMoorage,
  });
  const currentListing = ensureListing(listing);

  return (
    <div
      className={classes}
      onClick={e => {
        e.stopPropagation();
        e.nativeEvent?.stopImmediatePropagation?.();
        onListingClicked(currentListing);
      }}
    >
      <img
        className={classNames(css.pinImage, { [css.checkedPinImage]: !!activeCheckIn })}
        src={pinImage}
        alt={pinAlt}
      />
    </div>
  );
};

export default SearchMapIconPin;
